<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="页面标题">
				<el-input v-model="list.content" maxlength="13" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" class="add-image" @click="addList"> 添加列 </el-button>
			</el-form-item>
		</el-form>

		<el-form label-width="80px">
			<el-form-item class="listData" label="列名称" v-for="(item, index) in list.data" :key="index">
				<el-input v-model="list.data[index].lable" placeholder="请输入列名称"></el-input>
				<el-button type="danger" icon="el-icon-delete" circle @click="deleteListData(index)"></el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'Info',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {
		addList() {
			var index = this.list.data.length + 1;
			this.list.data.push({ lable: '', model: 'text' + index });
		},
		// inputChange(val) {
		// 	this.list = { ...this.list };
		// },
		deleteListData(val) {
			delete this.list.data.splice(val, 1);
			// this.inputChange();
		},
	},
};
</script>

<style lang="scss" scoped>
.info-content {
	padding: 20px;
}
.listData {
	.el-input {
		width: 160px;
	}
	.el-button {
		float: right;
	}
}
</style>